export class AANPublicationsDialog {
	init(): void {
		const showPublicationsButtons = Array.from(document.querySelectorAll("button.show-publications"));
		const publicationsDialog = document.getElementById("publications") as HTMLDialogElement;

		if (!publicationsDialog) {
			return;
		}

		showPublicationsButtons.forEach(showPublicationsButton => {
			showPublicationsButton.addEventListener("click", () => {
				if (!publicationsDialog.hasAttribute("open")) {
					// Not all browsers support the dialog element yet. as a result TypeScrupt doesn't recognize it.
					// We are polyfilling it so this will make TypeScript ignore the call.
					(publicationsDialog as any).showModal();
				} else {
					(publicationsDialog as any).close();
				}
			});
		});
	}
}


document.addEventListener("DOMContentLoaded", () => {
	const publicationsDialog = new AANPublicationsDialog();

	publicationsDialog.init();
});
